import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import PaletteRoundedIcon from "@mui/icons-material/PaletteRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import HubRoundedIcon from "@mui/icons-material/HubRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

export default function BrandSidebar() {

    const [collapsed, setCollapsed] = useState(false);

    const menus = [

        {
            label: "Overview",
            path: "/brand",
            icon: <DashboardRoundedIcon />
        },

        {
            label: "Products",
            path: "/brand/products",
            icon: <Inventory2RoundedIcon />
        },

        {
            label: "Services",
            path: "/brand/services",
            icon: <HandymanRoundedIcon />
        },

        {
            label: "Marketplace",
            path: "/brand/marketplace",
            icon: <StorefrontRoundedIcon />
        },

        {
            label: "Orders",
            path: "/brand/orders",
            icon: <ReceiptLongRoundedIcon />
        },

        {
            label: "Fulfillment",
            path: "/brand/fulfillment",
            icon: <LocalShippingRoundedIcon />
        },

        {
            label: "Customers",
            path: "/brand/customers",
            icon: <GroupsRoundedIcon />
        },

        {
            label: "Inventory",
            path: "/brand/inventory",
            icon: <WarehouseRoundedIcon />
        },

        {
            label: "Bookings",
            path: "/brand/bookings",
            icon: <EventAvailableRoundedIcon />
        },

        {
            label: "Payments",
            path: "/brand/payments",
            icon: <PaymentsRoundedIcon />
        },

        {
            label: "Marketing",
            path: "/brand/marketing",
            icon: <CampaignRoundedIcon />
        },

        {
            label: "Branding",
            path: "/brand/branding",
            icon: <PaletteRoundedIcon />
        },

        {
            label: "Analytics",
            path: "/brand/analytics",
            icon: <QueryStatsRoundedIcon />
        },

        {
            label: "CRM",
            path: "/brand/crm",
            icon: <HubRoundedIcon />
        },

        {
            label: "Customer Support",
            path: "/brand/support",
            icon: <SupportAgentRoundedIcon />
        },

        {
            label: "Brand Settings",
            path: "/brand/settings",
            icon: <SettingsRoundedIcon />
        }

    ];

    return (

        <div

            style={{

                width: collapsed ? 82 : 285,

                transition: "all .3s ease",

                display: "flex",

                flexDirection: "column",

                background:
                    "linear-gradient(180deg,rgb(255,0,204) 0%,rgb(206,0,165) 100%)",

                color: "#fff",

                backdropFilter: "blur(18px)",

                WebkitBackdropFilter: "blur(18px)",

                boxShadow:
                    "8px 0 30px rgba(0,0,0,.15)",

                borderRight:
                    "1px solid rgba(255,255,255,.15)",

                overflow: "hidden"

            }}

        >

            {/* Brand */}

            <div

                style={{

                    padding: collapsed ? 16 : 24,

                    display: "flex",

                    alignItems: "center",

                    justifyContent:
                        collapsed
                            ? "center"
                            : "space-between",

                    borderBottom:
                        "1px solid rgba(255,255,255,.15)"

                }}

            >

                {!collapsed && (

                    <div

                        style={{

                            display: "flex",

                            alignItems: "center",

                            gap: 14

                        }}

                    >

                        <div

                            style={{

                                width: 48,

                                height: 48,

                                borderRadius: 14,

                                background:
                                    "rgba(255,255,255,.18)",

                                display: "flex",

                                alignItems: "center",

                                justifyContent: "center",

                                fontSize: 20,

                                fontWeight: 700,

                                backdropFilter: "blur(10px)"

                            }}

                        >

                            M

                        </div>

                        <div>

                            <div

                                style={{

                                    fontWeight: 700,

                                    fontSize: 16

                                }}

                            >

                                myFAVV Brand

                            </div>

                            <div

                                style={{

                                    fontSize: 12,

                                    opacity: .75

                                }}

                            >

                                Business Suite

                            </div>

                        </div>

                    </div>

                )}

                <button

                    onClick={() => setCollapsed(!collapsed)}

                    style={{

                        width: 42,

                        height: 42,

                        borderRadius: 12,

                        border: "none",

                        cursor: "pointer",

                        background:
                            "rgba(255,255,255,.18)",

                        color: "#fff",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        backdropFilter: "blur(10px)",

                        transition: ".25s"

                    }}

                >

                    <MenuRoundedIcon />

                </button>

            </div>

            {/* Navigation */}

            <div

                style={{

                    flex: 1,

                    overflowY: "auto",

                    padding: 14

                }}

            >

                {menus.map((item) => (

                    <NavLink

                        key={item.path}

                        to={item.path}

                        end={item.path === "/brand"}

                        style={({ isActive }) => ({

                            display: "flex",

                            alignItems: "center",

                            gap: 16,

                            marginBottom: 8,

                            padding: collapsed
                                ? "14px"
                                : "14px 18px",

                            borderRadius: 16,

                            textDecoration: "none",

                            color: "#fff",

                            background: isActive
                                ? "rgba(255,255,255,.22)"
                                : "transparent",

                            transition:
                                "all .25s ease",

                            fontWeight:
                                isActive ? 600 : 500,

                            backdropFilter:
                                isActive
                                    ? "blur(10px)"
                                    : "none"

                        })}

                        onMouseEnter={(e) => {

                            if (!e.currentTarget.classList.contains("active")) {

                                e.currentTarget.style.background =
                                    "rgba(255,255,255,.12)";

                                e.currentTarget.style.transform =
                                    "translateX(4px)";

                            }

                        }}

                        onMouseLeave={(e) => {

                            if (!e.currentTarget.classList.contains("active")) {

                                e.currentTarget.style.background =
                                    "transparent";

                                e.currentTarget.style.transform =
                                    "translateX(0px)";

                            }

                        }}

                    >

                        <div

                            style={{

                                display: "flex",

                                alignItems: "center",

                                justifyContent: "center",

                                minWidth: 26

                            }}

                        >

                            {item.icon}

                        </div>

                        {!collapsed && (

                            <span

                                style={{

                                    whiteSpace: "nowrap",

                                    fontSize: 15

                                }}

                            >

                                {item.label}

                            </span>

                        )}

                    </NavLink>

                ))}

            </div>

        </div>

    );

}